/**
 *
 * Sorts array with string to have items with more '/' on top
 * Items with same amount of '/' ordered by length (longer string on top)
 *
 * @param seoUrls
 * @returns Array
 */
export const sortSeoUrls = (seoUrls = []) => {
    return seoUrls.sort((a, b) => {
        const numberOfPartsA = a.split('/').length
        const numberOfPartsB = b.split('/').length
        const numberOfPartsDifference = numberOfPartsB - numberOfPartsA;

        const lengthDifference = b.length - a.length

        // numberOfPartsDifference is much more important, so we multiply it by 100
        return 100 * numberOfPartsDifference + lengthDifference
    })
}